
{
  "familyId": "GET-WORTEL",
  "questions": [
    {
      "id": "GET-WORTEL-001",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Wat betekent $\\sqrt{9}$?",
      "context": null,
      "options": [
        "welk getal keer zichzelf geeft 9?",
        "9 × 2",
        "9 ÷ 2",
        "9 + 9"
      ],
      "correctAnswer": 0,
      "conceptId": "square_root_meaning",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat is een wortel?",
            "content": "Het wortelteken √ vraagt: welk getal × zichzelf = het getal onder het teken? Voorbeeld: √9 = 3, want 3 × 3 = 9."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het wortelteken √ stelt de vraag: welk getal vermenigvuldigd met zichzelf geeft dit getal? Bij √9 zoek je: ? × ? = 9. Dat is 3, want 3 × 3 = 9. Dus √9 = 3. De wortel is het omgekeerde van het kwadraat: 3² = 9 en √9 = 3.",
        "solutionSteps": [
          "√ betekent: welk getal × zichzelf = ...?",
          "Zoek: ? × ? = 9",
          "Probeer 3: 3 × 3 = 9 ✓",
          "Dus √9 = 3 — de wortel is het omgekeerde van het kwadraat"
        ],
        "distractorExplanations": {
          "0": "Goed! √9 betekent: welk getal × zichzelf = 9? Dat is 3, want 3 × 3 = 9.",
          "1": "9 × 2 = 18 — het wortelteken is geen vermenigvuldiging met 2. √ vraagt: welk getal × zichzelf = 9? Dat is 3.",
          "2": "9 ÷ 2 = 4,5 — het wortelteken is geen deling door 2. √ vraagt: welk getal × zichzelf = 9? Dat is 3.",
          "3": "9 + 9 = 18 — het wortelteken is geen optelling. √ vraagt: welk getal × zichzelf = 9? Dat is 3."
        }
      }
    },
    {
      "id": "GET-WORTEL-002",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{16}$ =",
      "context": null,
      "options": ["4", "8", "2", "256"],
      "correctAnswer": 0,
      "conceptId": "square_root_sixteen",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 16? Probeer: 4 × 4 = 16. ✓ Dus √16 = 4."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 16 geeft. Probeer 4: 4 × 4 = 16 ✓. Dus √16 = 4. Tip: leer de kwadraten uit je hoofd: 1, 4, 9, 16, 25, 36, 49, 64, 81, 100.",
        "solutionSteps": [
          "Zoek: ? × ? = 16",
          "Probeer 4: 4 × 4 = 16 ✓",
          "Dus √16 = 4",
          "Controleer met de kwadratentabel: 4² = 16, dus √16 = 4 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √16 = 4, want 4 × 4 = 16.",
          "1": "Je hebt waarschijnlijk 16 ÷ 2 = 8 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 16? Dat is 4 (niet 8, want 8 × 8 = 64).",
          "2": "2 × 2 = 4, niet 16. Probeer 4: 4 × 4 = 16 ✓. Dus √16 = 4.",
          "3": "Je hebt 16 × 16 = 256 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 16? Dat is 4."
        }
      }
    },
    {
      "id": "GET-WORTEL-003",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{25}$ =",
      "context": null,
      "options": ["5", "12,5", "50", "625"],
      "correctAnswer": 0,
      "conceptId": "square_root_twentyfive",
      "variantIndex": 3,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 25? Probeer: 5 × 5 = 25. ✓ Dus √25 = 5."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 25 geeft. Probeer 5: 5 × 5 = 25 ✓. Dus √25 = 5. Tip: 25 is het kwadraat van 5. Leer de kwadraten uit je hoofd!",
        "solutionSteps": [
          "Zoek: ? × ? = 25",
          "Probeer 5: 5 × 5 = 25 ✓",
          "Dus √25 = 5",
          "Controleer: 5² = 25, dus √25 = 5 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √25 = 5, want 5 × 5 = 25.",
          "1": "Je hebt waarschijnlijk 25 ÷ 2 = 12,5 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 25? Dat is 5.",
          "2": "Je hebt waarschijnlijk 25 × 2 = 50 berekend. Wortel is niet vermenigvuldigen met 2. Wortel: welk getal × zichzelf = 25? Dat is 5.",
          "3": "Je hebt 25 × 25 = 625 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 25? Dat is 5."
        }
      }
    },
    {
      "id": "GET-WORTEL-004",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{64}$ =",
      "context": null,
      "options": ["8", "32", "4", "4096"],
      "correctAnswer": 0,
      "conceptId": "square_root_sixtyfour",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 64? Probeer: 8 × 8 = 64. ✓ Dus √64 = 8."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 64 geeft. Probeer 8: 8 × 8 = 64 ✓. Dus √64 = 8. Tip: 64 = 2⁶, en √(2⁶) = 2³ = 8. Dit laat zien hoe machten en wortels samenhangen.",
        "solutionSteps": [
          "Zoek: ? × ? = 64",
          "Probeer 8: 8 × 8 = 64 ✓",
          "Dus √64 = 8",
          "Tip: 64 zit in de kwadratentabel: 8² = 64 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √64 = 8, want 8 × 8 = 64.",
          "1": "Je hebt waarschijnlijk 64 ÷ 2 = 32 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 64? Dat is 8 (niet 32, want 32 × 32 = 1024).",
          "2": "4 × 4 = 16, niet 64. Probeer 8: 8 × 8 = 64 ✓. Dus √64 = 8.",
          "3": "Je hebt 64 × 64 = 4096 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 64? Dat is 8."
        }
      }
    },
    {
      "id": "GET-WORTEL-005",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\sqrt{100}$ =",
      "context": null,
      "options": ["10", "50", "20", "10000"],
      "correctAnswer": 0,
      "conceptId": "square_root_hundred",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.82,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortel berekenen",
            "content": "Vraag jezelf: welk getal × zichzelf = 100? Probeer: 10 × 10 = 100. ✓ Dus √100 = 10."
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek het getal dat vermenigvuldigd met zichzelf 100 geeft. Probeer 10: 10 × 10 = 100 ✓. Dus √100 = 10. Dit is een makkelijk te onthouden wortel: √100 = 10.",
        "solutionSteps": [
          "Zoek: ? × ? = 100",
          "Probeer 10: 10 × 10 = 100 ✓",
          "Dus √100 = 10",
          "Controleer: 10² = 100, dus √100 = 10 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! √100 = 10, want 10 × 10 = 100.",
          "1": "Je hebt waarschijnlijk 100 ÷ 2 = 50 berekend, maar halveren is geen wortel. Wortel: welk getal × zichzelf = 100? Dat is 10.",
          "2": "20 × 20 = 400, niet 100. Probeer 10: 10 × 10 = 100 ✓. Dus √100 = 10.",
          "3": "Je hebt 100 × 100 = 10000 berekend — dat is het kwadraat, niet de wortel. Wortel is het omgekeerde: welk getal × zichzelf = 100? Dat is 10."
        }
      }
    },
    {
      "id": "GET-WORTEL-006",
      "familyId": "GET-WORTEL",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "wortel_basis",
      "questionType": "multiple_choice",
      "question": "Welke is groter: $\\sqrt{36}$ of $\\sqrt{49}$?",
      "context": null,
      "options": [
        "$\\sqrt{49}$",
        "$\\sqrt{36}$",
        "ze zijn even groot",
        "dat kun je niet zeggen"
      ],
      "correctAnswer": 0,
      "conceptId": "square_root_compare",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wortels vergelijken",
            "content": "Bereken beide wortels: √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 > √36."
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken beide wortels. √36 = 6 (want 6 × 6 = 36) en √49 = 7 (want 7 × 7 = 49). Vergelijk: 7 > 6, dus √49 is groter. Tip: een groter getal onder het wortelteken geeft altijd een grotere wortel. Dus je kunt ook zonder rekenen zien dat √49 > √36, want 49 > 36.",
        "solutionSteps": [
          "√36 = 6 (want 6 × 6 = 36)",
          "√49 = 7 (want 7 × 7 = 49)",
          "Vergelijk: 7 > 6",
          "Dus √49 > √36 — een groter getal onder √ geeft altijd een grotere wortel"
        ],
        "distractorExplanations": {
          "0": "Goed! √49 = 7 en √36 = 6, dus √49 > √36.",
          "1": "√36 = 6 en √49 = 7. Omdat 7 > 6, is √49 groter dan √36.",
          "2": "Ze zijn niet even groot. √36 = 6 en √49 = 7. Dat zijn verschillende getallen.",
          "3": "Je kunt het wél zeggen. Bereken beide: √36 = 6 en √49 = 7. Vergelijk: 7 > 6, dus √49 is groter."
        }
      }
    }
  ]
}
